var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * Represents an error
 *
 * @remarks
 * If the error originates from the Search API, the code and type property will be present.
 *
 * @public
 */
var SearchError = /** @class */ (function (_super) {
    __extends(SearchError, _super);
    /** @internal */
    function SearchError(message, code, type) {
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.code = code;
        _this.type = type;
        // When targeting ES5, it is necessary to manually set the prototype for instance of checks to work
        // See: "Extending built-ins like Error, Array, and Map may no longer work"
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes
        Object.setPrototypeOf(_this, SearchError.prototype);
        return _this;
    }
    return SearchError;
}(Error));
export { SearchError };
//# sourceMappingURL=SearchError.js.map